import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { css } from 'styled-components';

import { FontAwesomeIcon, IconDefinition } from '@sorare/core/src/atoms/icons';
import { Text16 } from '@sorare/core/src/atoms/typography';
import { VirtualToggleFilter } from '@sorare/core/src/lib/filters';

import { SegmentButton } from '../ui';
import { useVirtualFilterSegment } from './useVirtualFilterSegment';

type Props = {
  filter: VirtualToggleFilter;
  cleanableFilters?: VirtualToggleFilter[];
  needsLogin?: boolean;
  onClick?: (b: boolean) => void;
  icon: IconDefinition | null;
  customCss?: ReturnType<typeof css>;
  withoutText?: boolean;
};

export const VirtualFilterSegment = ({
  filter,
  cleanableFilters = [],
  icon,
  customCss,
  onClick,
  needsLogin = false,
  withoutText,
}: Props) => {
  const { checked, onChange } = useVirtualFilterSegment({
    filter,
    cleanableFilters,
    needsLogin,
    onChange: onClick,
  });
  return (
    <SegmentButton
      $customCss={customCss}
      className={classNames({ checked })}
      onClick={onChange}
    >
      <Text16 bold>
        {icon && <FontAwesomeIcon icon={icon} />}
        {icon && !withoutText && ' '}
        {!withoutText && (
          <>
            {'label' in filter && <FormattedMessage {...filter.label} />}
            {'title' in filter && <FormattedMessage {...filter.title} />}
          </>
        )}
      </Text16>
    </SegmentButton>
  );
};
